export const namedRoutes = {
  home: "/",
  almanac: "/almanac/:slug",
  news: "/news/:slug",
  artwork: "/artworks/:slug",
  events: "/events/:slug",
  venues: "/venues/:slug",
  projects: "/projects/:slug",
  people: "/people/:slug",
  single: "/:slug"
}

export function onAlmanac(path) {
  console.log(path.indexOf("/almanac"))
  return [0, 3].includes(path.indexOf("/almanac"))
}

export function onAlmanacHome(path) {
  return path == "/almanac"
    || path == "/almanac/"
    || path == "/almanac/list"
    || path == "/almanac/list/"
    || path == "/de/almanac"
    || path == "/de/almanac/"
    || path == "/de/almanac/list"
    || path == "/de/almanac/list/"
}